import SafeImage from "@/components/common/safe_image";
import CustomSVG from "../svg";
import classes from "./badge.module.css";
import dot from '@/assets/svg/_dot.svg';
import Avatar from "../avatar/avatar";

const leadingIconTypes = ["dot", "avatar", "left", "only", "country"];

export default function CustomBadge({children, size, icon, icon_type, is_svg, svg, color, avatar, country, nested, border, no_overflow, pointer, ...props}) {
    let badge_classes = `${classes.badge} ${classes[size]} ${classes[color]} ${icon ? classes[icon] : ''} ${(size === "sm" || (nested && size === "md")) ? "text-xs-medium" : "text-sm-medium"} ${nested ? `${classes.nested} ${classes[`nested-${nested}`]}` : ""} ${is_svg ? classes["svg-type"] : ""} ${border ? classes["border"] : ""} ${no_overflow ? classes["no_overflow"] : ""} ${pointer ? "pointer" : ""}`; 
    let icon_size = (nested ? 16 : 12)

    let badge_icon;
    if(icon) {
        switch(icon) {
            case "dot":
                badge_icon = <CustomSVG SvgFunction={dot} height={8} width={8} />
                break;
            case "country":
                badge_icon = <SafeImage src={country} height={16} width={16} alt="badge avatar" />
                break;
            case "avatar":
                badge_icon = <Avatar size="2xs" url={avatar} />
                break;
            default:
                if(is_svg) {
                    badge_icon = <CustomSVG SvgFunction={svg} height={icon_size} width={icon_size} />
                } else {
                    badge_icon = <i className={`bi bi-icon bi-icon-${icon_size} ${icon_type} ${classes["bs-icon"]}`}/>
                }
                break;
        }
    }

    if(nested) children = <span className={classes["children"]}>{children}</span>

    return <span className={badge_classes} {...props}>
        {icon && leadingIconTypes.includes(icon) && badge_icon}
        {(!icon || (icon && icon !== "only")) && children}
        {icon && (icon === "right") && badge_icon}
    </span>
}